// extracted by mini-css-extract-plugin
export var animateBox = "services-module--animate-box--d592a";
export var bottomFade = "services-module--bottom-fade--4fc48";
export var fullUp = "services-module--full-up--d1d90";
export var halfUp = "services-module--half-up--89ce3";
export var image = "services-module--image--c38b7";
export var imageCaption = "services-module--image-caption--0d784";
export var imageContainer = "services-module--image-container--5bc24";
export var imageWrapper = "services-module--image-wrapper--4d098";